import allowedMutation from "./allowedMutation";
/**
 * Checks event and eventStaffFunctionsConf allowedMutations whether user can
 * manage event staff function configuration
 * @param event Event object (allowedMutations required!)
 * @param eventStaffFunctionsConf EventStaffFunctionsConf object (allowedMutations required!)
 * @returns boolean whether user can manage staff function configuration
 */
export function canManageEventStaffFunctionsConf(event, eventStaffFunctionsConf) {
    return (allowedMutation(event.allowedMutations, [
        "eventStaffFunctionsConfCreate"
    ]) ||
        allowedMutation(eventStaffFunctionsConf.allowedMutations, "eventStaffFunctionsConfUpdate"));
}
